import api from './api';

const configService = {
  // Obtener todas las configuraciones
  getConfigs: async () => {
    return await api.get('/config');
  },

  // Obtener configuración por clave
  getConfig: async (clave) => {
    return await api.get(`/config/${clave}`);
  },

  // Actualizar configuración
  updateConfig: async (clave, data) => {
    return await api.put(`/config/${clave}`, data);
  }
};

export default configService;